import { Badge } from 'design-system';

type SelectWidgetProps = {
  icon?: React.ReactNode;
  title: string;
  description?: string;
  onSelect: () => void;
  soon?: boolean;
  badge?: string;
  testId?: string;
  disabled?: boolean;
};

const SelectWidget = ({
  badge,
  icon,
  title,
  description,

  onSelect,
  soon = false,
  testId,
  disabled = false
}: SelectWidgetProps) => {
  const badgeLabel = soon ? 'Coming Soon' : badge;
  const unavailable = soon || disabled;

  return (
    <button
      type='button'
      data-testid={testId}
      disabled={unavailable}
      className='flex w-full flex-col gap-3 rounded-xl border border-border bg-card p-4 text-left text-card-foreground transition-colors hover:bg-muted disabled:cursor-default disabled:opacity-50'
      onClick={onSelect}
    >
      <span
        data-testid='widget-icon'
        className='flex flex-wrap items-center gap-2 text-xl'
      >
        {icon}
        <span
          data-testid='widget-title'
          className='inline-flex items-center font-semibold'
        >
          {title}
        </span>
        {badgeLabel && (
          <span
            data-testid={soon ? 'widget-soon' : 'widget-badge'}
            className='ml-1 inline-flex shrink-0 items-center justify-center'
          >
            <Badge variant={soon ? 'neutralOutline' : 'muted'}>{badgeLabel}</Badge>
          </span>
        )}
      </span>
      {description && (
        <span
          data-testid='widget-description'
          className='text-sm text-muted-foreground'
        >
          {description}
        </span>
      )}
    </button>
  );
};
export default SelectWidget;
